import { Helmet } from "react-helmet-async";

const SITE_NAME = "FR INTERIM";
const SITE_URL = "https://fr-interim.fr";
const LOGO_URL = "https://customer-assets.emergentagent.com/job_c50239db-e303-4ac2-9fad-ed65c9848429/artifacts/l9apbe3g_LOGO-FR-INTERIM.png";

export function SEO({ title, description, path = "/", type = "website", jsonLd = null }) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} - Agence d'intérim spécialisée logistique`;
  const url = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:image" content={LOGO_URL} />
      <meta property="og:locale" content="fr_FR" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={LOGO_URL} />

      {/* JSON-LD */}
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}

export const ORGANIZATION_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "EmploymentAgency",
  "name": "FR INTERIM",
  "description": "Agence de travail temporaire spécialisée dans les métiers de la logistique et de la supply chain",
  "url": SITE_URL,
  "logo": LOGO_URL,
  "sameAs": [],
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "FR"
  },
  "areaServed": {
    "@type": "Country",
    "name": "France"
  },
  "knowsAbout": [
    "Intérim logistique",
    "Préparation de commandes",
    "Cariste",
    "Manutention",
    "Gestion de stocks",
    "Supply chain",
    "Transport"
  ]
};

export function jobPostingSchema(offer) {
  return {
    "@context": "https://schema.org",
    "@type": "JobPosting",
    "title": offer.title,
    "description": offer.description,
    "identifier": {
      "@type": "PropertyValue",
      "name": "FR INTERIM",
      "value": offer.offer_number || offer.offer_id
    },
    "datePosted": offer.created_at?.split("T")[0] || new Date().toISOString().split("T")[0],
    "validThrough": offer.mission_end || undefined,
    "employmentType": "TEMPORARY",
    "hiringOrganization": {
      "@type": "Organization",
      "name": "FR INTERIM",
      "sameAs": SITE_URL,
      "logo": LOGO_URL
    },
    "jobLocation": offer.location ? {
      "@type": "Place",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": offer.location,
        "addressCountry": "FR"
      }
    } : undefined,
    "baseSalary": offer.salary ? {
      "@type": "MonetaryAmount",
      "currency": "EUR",
      "value": {
        "@type": "QuantitativeValue",
        "value": offer.salary
      }
    } : undefined,
    "industry": "Logistique et Supply Chain",
    "occupationalCategory": offer.profile_needed || "Logistique"
  };
}
